var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "download-app" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-4 mx-auto" }, [
        _c("a", { staticClass: "logo", attrs: { href: "" } }, [
          _c("img", {
            staticStyle: { width: "150px" },
            attrs: { src: _vm.websiteLogo }
          })
        ]),
        _c("h2", { staticClass: "heading" }, [
          _vm._v(
            _vm._s(
              _vm._f("trans")("st_public.Download Who App and See Full Result")
            )
          )
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "info" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$route.params.slug))]),
            _c("div", { staticClass: "avatar" }, [
              _c("div", { staticClass: "lock" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "32",
                      height: "36",
                      viewBox: "0 0 32 36",
                      fill: "none"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M15.7836 0C10.5165 0 6.23134 3.96375 6.23134 8.83582V14.1373H4.3209C2.21176 14.1373 0.5 15.7207 0.5 17.6716V31.809C0.5 33.7599 2.21176 35.3433 4.3209 35.3433H8.14179H13.8731H17.694H21.5149H27.2463C29.3554 35.3433 31.0672 33.7599 31.0672 31.809V17.6716C31.0672 15.7207 29.3554 14.1373 27.2463 14.1373H25.3358V8.83582C25.3358 3.96375 21.0507 0 15.7836 0ZM10.0522 8.83582C10.0522 5.91293 12.6237 3.53433 15.7836 3.53433C18.9435 3.53433 21.5149 5.91293 21.5149 8.83582V14.1373H10.0522V8.83582ZM17.694 27.7851V31.809H13.8731V27.7851C12.4842 27.0394 11.6398 25.5267 12.0792 23.8549C12.4155 22.5826 13.5694 21.5541 14.9564 21.2873C17.4285 20.8066 19.6045 22.5366 19.6045 24.7403C19.6045 26.0462 18.8327 27.1737 17.694 27.7851Z",
                        fill: "white"
                      }
                    })
                  ]
                )
              ]),
              _c("div", { staticClass: "verified" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M11 5.53999V5.99999C10.9994 7.0782 10.6502 8.12733 10.0047 8.99091C9.35908 9.85448 8.45164 10.4862 7.41768 10.7919C6.38371 11.0977 5.27863 11.0609 4.26723 10.6873C3.25584 10.3136 2.39233 9.62304 1.80548 8.71853C1.21863 7.81401 0.939896 6.74403 1.01084 5.66815C1.08178 4.59228 1.4986 3.56816 2.19914 2.74853C2.89968 1.9289 3.84639 1.35768 4.89809 1.12007C5.9498 0.882448 7.05013 0.991162 8.035 1.42999",
                        stroke: "#7ED6AE",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    }),
                    _c("path", {
                      attrs: {
                        d: "M11 2L6 7.005L4.5 5.505",
                        stroke: "#7ED6AE",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    })
                  ]
                ),
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.verified Result")) +
                    "\n            "
                )
              ])
            ]),
            _c("div", { staticClass: "element" })
          ]),
          _c("div", { staticClass: "results" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm._f("trans")("st_public.Results May Include")))
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.Full Name Address")) +
                    "\n            "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.Birth Day")) +
                    "\n            "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.Dowload Email Address")) +
                    "\n            "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.Phone Number")) +
                    "\n            "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.Relationship Status")) +
                    "\n            "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.Location History")) +
                    "\n            "
                )
              ])
            ])
          ])
        ]),
        _c(
          "a",
          {
            staticClass: "download-app-btn",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.download_app()
              }
            }
          },
          [_vm._v(_vm._s(_vm._f("trans")("st_public.CONTINUE ON MOBILE APP")))]
        ),
        _c("p", { staticClass: "join-hint" }, [
          _vm._v(
            _vm._s(
              _vm._f("trans")(
                "st_public.Join 10M+ Users Search Over 1 Billion Records"
              )
            )
          )
        ]),
        _c("div", { staticClass: "store" }, [
          _c(
            "a",
            { attrs: { href: "https://apps.apple.com/app/id1547222690" } },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "135",
                    height: "40",
                    viewBox: "0 0 135 40",
                    fill: "none"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      x: "0.165",
                      y: "0.165",
                      width: "134.67",
                      height: "39.67",
                      rx: "6.835",
                      fill: "#787880",
                      "fill-opacity": "0.16"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M81.5257 19.2013V21.4924H80.0896V22.9948H81.5257V28.0998C81.5257 29.8429 82.3143 30.5402 84.2981 30.5402C84.6468 30.5402 84.9788 30.4987 85.2693 30.4489V28.9631C85.0203 28.988 84.8626 29.0046 84.5887 29.0046C83.7005 29.0046 83.3104 28.5895 83.3104 27.6432V22.9948H85.2693V21.4924H83.3104V19.2013H81.5257Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M90.3232 30.6647C92.9628 30.6647 94.5815 28.8967 94.5815 25.9665C94.5815 23.0529 92.9545 21.2765 90.3232 21.2765C87.6835 21.2765 86.0566 23.0529 86.0566 25.9665C86.0566 28.8967 87.6752 30.6647 90.3232 30.6647ZM90.3232 29.0793C88.7709 29.0793 87.8994 27.9421 87.8994 25.9665C87.8994 24.0075 88.7709 22.862 90.3232 22.862C91.8671 22.862 92.747 24.0075 92.747 25.9665C92.747 27.9338 91.8671 29.0793 90.3232 29.0793Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M95.9664 30.4904H97.7511V25.153C97.7511 23.883 98.7056 23.028 100.059 23.028C100.374 23.028 100.905 23.0861 101.055 23.1359V21.3762C100.864 21.3263 100.524 21.3014 100.258 21.3014C99.0792 21.3014 98.0748 21.9489 97.8175 22.8371H97.6846V21.4509H95.9664V30.4904Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M105.486 22.7956C106.806 22.7956 107.669 23.717 107.711 25.1364H103.145C103.245 23.7253 104.166 22.7956 105.486 22.7956ZM107.702 28.05C107.37 28.7555 106.632 29.1457 105.552 29.1457C104.125 29.1457 103.203 28.1413 103.145 26.5558V26.4562H109.529V25.8337C109.529 22.9948 108.009 21.2765 105.494 21.2765C102.946 21.2765 101.327 23.111 101.327 25.9997C101.327 28.8884 102.913 30.6647 105.503 30.6647C107.57 30.6647 109.014 29.6686 109.421 28.05H107.702Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M69.8221 27.1522C69.9598 29.372 71.8095 30.7915 74.5626 30.7915C77.505 30.7915 79.3462 29.3031 79.3462 26.9286C79.3462 25.0616 78.2966 24.0292 75.7499 23.4355L74.382 23.1C72.7645 22.7214 72.1106 22.2138 72.1106 21.3277C72.1106 20.2092 73.1259 19.4779 74.6487 19.4779C76.0941 19.4779 77.0921 20.192 77.2727 21.3363H79.1483C79.0365 19.2456 77.1953 17.7744 74.6745 17.7744C71.9644 17.7744 70.1576 19.2456 70.1576 21.4567C70.1576 23.2807 71.1815 24.3647 73.427 24.8895L75.0272 25.2767C76.6705 25.6638 77.3932 26.2317 77.3932 27.1781C77.3932 28.2793 76.2575 29.0794 74.7089 29.0794C73.0484 29.0794 71.8955 28.3309 71.7321 27.1522H69.8221Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M51.3348 21.3014C50.1063 21.3014 49.0437 21.9157 48.4959 22.945H48.3631V21.4509H46.6448V33.4953H48.4295V29.1208H48.5706C49.0437 30.0754 50.0647 30.6398 51.3514 30.6398C53.6341 30.6398 55.0867 28.8386 55.0867 25.9665C55.0867 23.0944 53.6341 21.3014 51.3348 21.3014ZM50.8284 29.0378C49.3343 29.0378 48.3963 27.8591 48.3963 25.9748C48.3963 24.0822 49.3343 22.9035 50.8367 22.9035C52.3475 22.9035 53.2522 24.0573 53.2522 25.9665C53.2522 27.884 52.3475 29.0378 50.8284 29.0378Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M61.3316 21.3014C60.103 21.3014 59.0405 21.9157 58.4927 22.945H58.3599V21.4509H56.6416V33.4953H58.4263V29.1208H58.5674C59.0405 30.0754 60.0615 30.6398 61.3482 30.6398C63.6309 30.6398 65.0835 28.8386 65.0835 25.9665C65.0835 23.0944 63.6309 21.3014 61.3316 21.3014ZM60.8252 29.0378C59.3311 29.0378 58.3931 27.8591 58.3931 25.9748C58.3931 24.0822 59.3311 22.9035 60.8335 22.9035C62.3443 22.9035 63.249 24.0573 63.249 25.9665C63.249 27.884 62.3443 29.0378 60.8252 29.0378Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M43.4428 30.4904H45.4905L41.008 18.0755H38.9346L34.4521 30.4904H36.431L37.5752 27.1953H42.3072L43.4428 30.4904ZM39.8724 20.3297H40.0186L41.8168 25.5778H38.0656L39.8724 20.3297Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M35.6514 8.71069V14.6997H37.8137C39.5984 14.6997 40.6318 13.5999 40.6318 11.6865C40.6318 9.80225 39.5901 8.71069 37.8137 8.71069H35.6514ZM36.5811 9.55737H37.71C38.9509 9.55737 39.6855 10.3459 39.6855 11.699C39.6855 13.0728 38.9634 13.853 37.71 13.853H36.5811V9.55737Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M43.7969 14.7869C45.1167 14.7869 45.9261 13.9028 45.9261 12.4377C45.9261 10.981 45.1126 10.0928 43.7969 10.0928C42.4771 10.0928 41.6636 10.981 41.6636 12.4377C41.6636 13.9028 42.4729 14.7869 43.7969 14.7869ZM43.7969 13.9941C43.0208 13.9941 42.585 13.4255 42.585 12.4377C42.585 11.4583 43.0208 10.8855 43.7969 10.8855C44.5689 10.8855 45.0088 11.4583 45.0088 12.4377C45.0088 13.4214 44.5689 13.9941 43.7969 13.9941Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M52.8182 10.1799H51.9259L51.1207 13.6289H51.0501L50.1205 10.1799H49.2655L48.3358 13.6289H48.2694L47.4601 10.1799H46.5553L47.8004 14.6997H48.7176L49.6473 11.3711H49.7179L50.6517 14.6997H51.5772L52.8182 10.1799Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M53.8458 14.6997H54.7382V12.0559C54.7382 11.3503 55.1574 10.9104 55.8173 10.9104C56.4772 10.9104 56.7926 11.2715 56.7926 11.9978V14.6997H57.685V11.7737C57.685 10.6987 57.1288 10.0928 56.1203 10.0928C55.4396 10.0928 54.9914 10.3958 54.7714 10.8979H54.705V10.1799H53.8458V14.6997Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d: "M59.0903 14.6997H59.9826V8.41602H59.0903V14.6997Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M63.3386 14.7869C64.6584 14.7869 65.4678 13.9028 65.4678 12.4377C65.4678 10.981 64.6543 10.0928 63.3386 10.0928C62.0188 10.0928 61.2053 10.981 61.2053 12.4377C61.2053 13.9028 62.0146 14.7869 63.3386 14.7869ZM63.3386 13.9941C62.5625 13.9941 62.1267 13.4255 62.1267 12.4377C62.1267 11.4583 62.5625 10.8855 63.3386 10.8855C64.1106 10.8855 64.5505 11.4583 64.5505 12.4377C64.5505 13.4214 64.1106 13.9941 63.3386 13.9941Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M68.1265 14.0232C67.6409 14.0232 67.2881 13.7866 67.2881 13.3799C67.2881 12.9814 67.5704 12.7698 68.1929 12.7283L69.2969 12.6577V13.0354C69.2969 13.5957 68.7989 14.0232 68.1265 14.0232ZM67.8982 14.7744C68.4917 14.7744 68.9856 14.5171 69.2554 14.0647H69.326V14.6997H70.1851V11.6118C70.1851 10.6572 69.5459 10.0928 68.4129 10.0928C67.3877 10.0928 66.6573 10.5908 66.566 11.3669H67.4292C67.5289 11.0474 67.8733 10.8647 68.3714 10.8647C68.9815 10.8647 69.2969 11.1345 69.2969 11.6118V12.002L68.0726 12.0725C66.9976 12.1389 66.3916 12.6079 66.3916 13.4214C66.3916 14.2473 67.0267 14.7744 67.8982 14.7744Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M73.2132 14.7744C73.8358 14.7744 74.3629 14.4797 74.6327 13.9858H74.7032V14.6997H75.5582V8.41602H74.6659V10.8979H74.5995C74.3546 10.3999 73.8316 10.1052 73.2132 10.1052C72.0719 10.1052 71.3373 11.01 71.3373 12.4377C71.3373 13.8696 72.0636 14.7744 73.2132 14.7744ZM73.4664 10.9062C74.2135 10.9062 74.6825 11.4998 74.6825 12.4419C74.6825 13.3882 74.2176 13.9734 73.4664 13.9734C72.711 13.9734 72.2586 13.3965 72.2586 12.4377C72.2586 11.4873 72.7152 10.9062 73.4664 10.9062Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M81.3447 14.7869C82.6645 14.7869 83.4738 13.9028 83.4738 12.4377C83.4738 10.981 82.6604 10.0928 81.3447 10.0928C80.0249 10.0928 79.2114 10.981 79.2114 12.4377C79.2114 13.9028 80.0207 14.7869 81.3447 14.7869ZM81.3447 13.9941C80.5686 13.9941 80.1328 13.4255 80.1328 12.4377C80.1328 11.4583 80.5686 10.8855 81.3447 10.8855C82.1166 10.8855 82.5566 11.4583 82.5566 12.4377C82.5566 13.4214 82.1166 13.9941 81.3447 13.9941Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M84.655 14.6997H85.5474V12.0559C85.5474 11.3503 85.9666 10.9104 86.6265 10.9104C87.2864 10.9104 87.6018 11.2715 87.6018 11.9978V14.6997H88.4941V11.7737C88.4941 10.6987 87.938 10.0928 86.9294 10.0928C86.2488 10.0928 85.8005 10.3958 85.5806 10.8979H85.5142V10.1799H84.655V14.6997Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M92.6039 9.05518V10.2007H91.8858V10.9519H92.6039V13.5044C92.6039 14.376 92.9981 14.7246 93.9901 14.7246C94.1644 14.7246 94.3304 14.7039 94.4757 14.679V13.936C94.3512 13.9485 94.2723 13.9568 94.1353 13.9568C93.6913 13.9568 93.4962 13.7493 93.4962 13.2761V10.9519H94.4757V10.2007H93.4962V9.05518H92.6039Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M95.6735 14.6997H96.5658V12.0601C96.5658 11.3752 96.9726 10.9146 97.703 10.9146C98.3339 10.9146 98.6701 11.2798 98.6701 12.002V14.6997H99.5624V11.782C99.5624 10.707 98.9689 10.0969 98.006 10.0969C97.3253 10.0969 96.848 10.3999 96.6281 10.9062H96.5575V8.41602H95.6735V14.6997Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M102.781 10.8523C103.441 10.8523 103.873 11.313 103.894 12.0227H101.611C101.661 11.3171 102.122 10.8523 102.781 10.8523ZM103.89 13.4795C103.724 13.8323 103.354 14.0273 102.815 14.0273C102.101 14.0273 101.64 13.5251 101.611 12.7324V12.6826H104.803V12.3713C104.803 10.9519 104.043 10.0928 102.786 10.0928C101.511 10.0928 100.702 11.01 100.702 12.4543C100.702 13.8987 101.495 14.7869 102.79 14.7869C103.823 14.7869 104.545 14.2888 104.749 13.4795H103.89Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M24.769 20.3011C24.7907 18.6201 25.6934 17.0295 27.1256 16.149C26.2221 14.8587 24.7088 14.0406 23.1344 13.9913C21.4552 13.8151 19.8272 14.9962 18.9715 14.9962C18.0992 14.9962 16.7817 14.0088 15.363 14.038C13.5137 14.0978 11.7898 15.1491 10.8901 16.7659C8.95607 20.1143 10.3987 25.0354 12.2513 27.742C13.1782 29.0673 14.2615 30.5478 15.6789 30.4953C17.066 30.4377 17.584 29.6108 19.2583 29.6108C20.9171 29.6108 21.4031 30.4953 22.8493 30.4619C24.3377 30.4377 25.2754 29.1306 26.1698 27.7927C26.8358 26.8484 27.3483 25.8047 27.6882 24.7002C25.9391 23.9604 24.771 22.2002 24.769 20.3011Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M22.0373 12.2113C22.8489 11.2371 23.2487 9.98494 23.1518 8.7207C21.912 8.85092 20.7668 9.44348 19.9443 10.3803C19.14 11.2956 18.7214 12.5258 18.8006 13.7417C20.0408 13.7545 21.2601 13.178 22.0373 12.2113Z",
                      fill: "white"
                    }
                  }),
                  _c("rect", {
                    attrs: {
                      x: "0.165",
                      y: "0.165",
                      width: "134.67",
                      height: "39.67",
                      rx: "6.835",
                      stroke: "white",
                      "stroke-width": "0.33"
                    }
                  })
                ]
              )
            ]
          ),
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://play.google.com/store/apps/details?id=com.cascadialabs.who"
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "136",
                    height: "40",
                    viewBox: "0 0 136 40",
                    fill: "none"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      x: "0.336875",
                      y: "0.165",
                      width: "134.67",
                      height: "39.67",
                      rx: "6.835",
                      fill: "#787880",
                      "fill-opacity": "0.16"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M68.3079 21.7509C65.9559 21.7509 64.0389 23.5399 64.0389 26.0039C64.0389 28.4529 65.9559 30.2569 68.3079 30.2569C70.6609 30.2569 72.5779 28.4529 72.5779 26.0039C72.5769 23.5399 70.6599 21.7509 68.3079 21.7509ZM68.3079 28.5829C67.0189 28.5829 65.9079 27.5199 65.9079 26.0049C65.9079 24.4739 67.0199 23.4269 68.3079 23.4269C69.5969 23.4269 70.7079 24.4739 70.7079 26.0049C70.7079 27.5189 69.5969 28.5829 68.3079 28.5829ZM58.9939 21.7509C56.6419 21.7509 54.7249 23.5399 54.7249 26.0039C54.7249 28.4529 56.6419 30.2569 58.9939 30.2569C61.3469 30.2569 63.2639 28.4529 63.2639 26.0039C63.2639 23.5399 61.3469 21.7509 58.9939 21.7509ZM58.9939 28.5829C57.7049 28.5829 56.5939 27.5199 56.5939 26.0049C56.5939 24.4739 57.7059 23.4269 58.9939 23.4269C60.2829 23.4269 61.3939 24.4739 61.3939 26.0049C61.3949 27.5189 60.2829 28.5829 58.9939 28.5829ZM47.9159 23.0569V24.8609H52.2339C52.1049 25.8759 51.7669 26.6169 51.2509 27.1319C50.6229 27.7599 49.6399 28.4529 47.9159 28.4529C45.2579 28.4529 43.1799 26.3099 43.1799 23.6519C43.1799 20.9939 45.2579 18.8509 47.9159 18.8509C49.3499 18.8509 50.3969 19.4149 51.1699 20.1399L52.4429 18.8669C51.3629 17.8359 49.9299 17.0469 47.9159 17.0469C44.2749 17.0469 41.2139 20.0109 41.2139 23.6519C41.2139 27.2929 44.2749 30.2569 47.9159 30.2569C49.8809 30.2569 51.3639 29.6119 52.5229 28.4039C53.7149 27.2119 54.0859 25.5359 54.0859 24.1829C54.0859 23.7649 54.0539 23.3779 53.9889 23.0559H47.9159V23.0569ZM93.2239 24.4579C92.8699 23.5079 91.7899 21.7509 89.5829 21.7509C87.3919 21.7509 85.5709 23.4749 85.5709 26.0039C85.5709 28.3879 87.3759 30.2569 89.7919 30.2569C91.7409 30.2569 92.8689 29.0649 93.3369 28.3719L91.8869 27.4049C91.4039 28.1139 90.7429 28.5809 89.7919 28.5809C88.8419 28.5809 88.1649 28.1459 87.7299 27.2919L93.4169 24.9399L93.2239 24.4579ZM87.4239 25.8759C87.3759 24.2319 88.6969 23.3949 89.6479 23.3949C90.3889 23.3949 91.0169 23.7659 91.2269 24.2969L87.4239 25.8759ZM82.8009 29.9999H84.6689V17.4989H82.8009V29.9999ZM79.7389 22.7019H79.6749C79.2559 22.2019 78.4499 21.7509 77.4359 21.7509C75.3089 21.7509 73.3599 23.6199 73.3599 26.0209C73.3599 28.4049 75.3089 30.2579 77.4359 30.2579C78.4509 30.2579 79.2559 29.8069 79.6749 29.2919H79.7389V29.9039C79.7389 31.5309 78.8689 32.4009 77.4679 32.4009C76.3239 32.4009 75.6149 31.5799 75.3249 30.8869L73.6979 31.5639C74.1649 32.6909 75.4049 34.0769 77.4679 34.0769C79.6589 34.0769 81.5119 32.7879 81.5119 29.6459V22.0099H79.7399V22.7019H79.7389ZM77.5969 28.5829C76.3079 28.5829 75.2289 27.5029 75.2289 26.0209C75.2289 24.5219 76.3079 23.4269 77.5969 23.4269C78.8689 23.4269 79.8679 24.5219 79.8679 26.0209C79.8679 27.5029 78.8689 28.5829 77.5969 28.5829ZM101.978 17.4989H97.5069V29.9999H99.3719V25.2639H101.977C104.045 25.2639 106.079 23.7669 106.079 21.3819C106.079 18.9969 104.046 17.4989 101.978 17.4989ZM102.026 23.5239H99.3719V19.2389H102.026C103.421 19.2389 104.213 20.3939 104.213 21.3819C104.213 22.3499 103.421 23.5239 102.026 23.5239ZM113.558 21.7289C112.207 21.7289 110.808 22.3239 110.229 23.6429L111.885 24.3339C112.239 23.6429 112.899 23.4169 113.59 23.4169C114.555 23.4169 115.536 23.9959 115.552 25.0249V25.1539C115.214 24.9609 114.49 24.6719 113.606 24.6719C111.821 24.6719 110.003 25.6529 110.003 27.4859C110.003 29.1589 111.467 30.2359 113.107 30.2359C114.361 30.2359 115.053 29.6729 115.487 29.0129H115.551V29.9779H117.353V25.1849C117.354 22.9669 115.696 21.7289 113.558 21.7289ZM113.332 28.5799C112.722 28.5799 111.869 28.2739 111.869 27.5179C111.869 26.5529 112.931 26.1829 113.848 26.1829C114.667 26.1829 115.054 26.3599 115.552 26.6009C115.407 27.7599 114.41 28.5799 113.332 28.5799ZM123.915 22.0019L121.776 27.4219H121.712L119.492 22.0019H117.482L120.811 29.5769L118.913 33.7909H120.859L125.99 22.0019H123.915ZM107.109 29.9999H108.974V17.4989H107.109V29.9999Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M47.5894 10.2432C47.5894 11.0812 47.3414 11.7482 46.8444 12.2462C46.2804 12.8382 45.5444 13.1342 44.6404 13.1342C43.7744 13.1342 43.0374 12.8342 42.4324 12.2342C41.8264 11.6332 41.5234 10.8892 41.5234 10.0012C41.5234 9.11219 41.8264 8.36819 42.4324 7.76819C43.0374 7.16719 43.7744 6.86719 44.6404 6.86719C45.0704 6.86719 45.4814 6.95119 45.8714 7.11819C46.2624 7.28619 46.5754 7.50919 46.8094 7.78819L46.2824 8.31619C45.8854 7.84119 45.3384 7.60419 44.6394 7.60419C44.0074 7.60419 43.4614 7.82619 43.0004 8.27019C42.5394 8.71419 42.3094 9.29119 42.3094 10.0002C42.3094 10.7092 42.5394 11.2862 43.0004 11.7302C43.4614 12.1742 44.0074 12.3962 44.6394 12.3962C45.3094 12.3962 45.8684 12.1732 46.3154 11.7262C46.6054 11.4352 46.7734 11.0302 46.8184 10.5112H44.6394V9.79019H47.5464C47.5764 9.94719 47.5894 10.0982 47.5894 10.2432Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M52.1995 7.73724H49.4675V9.63924H51.9315V10.3602H49.4675V12.2622H52.1995V13.0002H48.6965V7.00024H52.1995V7.73724Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M55.4504 13.0002H54.6794V7.73724H53.0034V7.00024H57.1264V7.73724H55.4504V13.0002Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d: "M60.1094 13.0002V7.00024H60.8804V13.0002H60.1094Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M64.2995 13.0002H63.5285V7.73724H61.8525V7.00024H65.9755V7.73724H64.2995V13.0002Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M73.7803 12.2252C73.1903 12.8312 72.4573 13.1342 71.5803 13.1342C70.7033 13.1342 69.9703 12.8312 69.3813 12.2252C68.7913 11.6192 68.4973 10.8772 68.4973 10.0002C68.4973 9.12323 68.7913 8.38123 69.3813 7.77523C69.9703 7.16923 70.7033 6.86523 71.5803 6.86523C72.4523 6.86523 73.1843 7.17023 73.7763 7.77923C74.3683 8.38823 74.6643 9.12823 74.6643 10.0002C74.6643 10.8772 74.3693 11.6192 73.7803 12.2252ZM69.9503 11.7222C70.3943 12.1722 70.9373 12.3962 71.5803 12.3962C72.2233 12.3962 72.7673 12.1712 73.2103 11.7222C73.6543 11.2722 73.8773 10.6982 73.8773 10.0002C73.8773 9.30223 73.6543 8.72823 73.2103 8.27823C72.7673 7.82823 72.2233 7.60423 71.5803 7.60423C70.9373 7.60423 70.3943 7.82923 69.9503 8.27823C69.5073 8.72823 69.2843 9.30223 69.2843 10.0002C69.2843 10.6982 69.5073 11.2722 69.9503 11.7222Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M75.7463 13.0002V7.00024H76.6843L79.6003 11.6672H79.6333L79.6003 10.5112V7.00024H80.3713V13.0002H79.5663L76.5153 8.10625H76.4823L76.5153 9.26224V13.0002H75.7463Z",
                      fill: "white"
                    }
                  }),
                  _c(
                    "g",
                    { attrs: { filter: "url(#filter0_ii_11510_19679)" } },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M10.6075 7.53784C10.3165 7.84584 10.1445 8.32384 10.1445 8.94284V31.0588C10.1445 31.6788 10.3165 32.1558 10.6075 32.4638L10.6815 32.5358L23.0705 20.1468V20.0008V19.8548L10.6815 7.46484L10.6075 7.53784Z",
                          fill: "url(#paint0_linear_11510_19679)"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M27.1993 24.2776L23.0703 20.1466V20.0006V19.8546L27.2003 15.7246L27.2933 15.7776L32.1863 18.5576C33.5833 19.3516 33.5833 20.6506 32.1863 21.4456L27.2933 24.2256L27.1993 24.2776Z",
                          fill: "url(#paint1_linear_11510_19679)"
                        }
                      }),
                      _c(
                        "g",
                        { attrs: { filter: "url(#filter1_i_11510_19679)" } },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M27.2934 24.225L23.0694 20.001L10.6074 32.464C11.0674 32.952 11.8284 33.012 12.6854 32.526L27.2934 24.225Z",
                              fill: "url(#paint2_linear_11510_19679)"
                            }
                          })
                        ]
                      ),
                      _c("path", {
                        attrs: {
                          d:
                            "M27.2934 15.7767L12.6854 7.4767C11.8284 6.9897 11.0674 7.0507 10.6074 7.5387L23.0704 20.0017L27.2934 15.7767Z",
                          fill: "url(#paint3_linear_11510_19679)"
                        }
                      })
                    ]
                  ),
                  _c("rect", {
                    attrs: {
                      x: "0.336875",
                      y: "0.165",
                      width: "134.67",
                      height: "39.67",
                      rx: "6.835",
                      stroke: "white",
                      "stroke-width": "0.33"
                    }
                  }),
                  _c(
                    "defs",
                    [
                      _c(
                        "filter",
                        {
                          attrs: {
                            id: "filter0_ii_11510_19679",
                            x: "10.1445",
                            y: "7.14062",
                            width: "23.0898",
                            height: "25.7207",
                            filterUnits: "userSpaceOnUse",
                            "color-interpolation-filters": "sRGB"
                          }
                        },
                        [
                          _c("feFlood", {
                            attrs: {
                              "flood-opacity": "0",
                              result: "BackgroundImageFix"
                            }
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in: "SourceGraphic",
                              in2: "BackgroundImageFix",
                              result: "shape"
                            }
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              in: "SourceAlpha",
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                              result: "hardAlpha"
                            }
                          }),
                          _c("feOffset", { attrs: { dy: "-0.15" } }),
                          _c("feComposite", {
                            attrs: {
                              in2: "hardAlpha",
                              operator: "arithmetic",
                              k2: "-1",
                              k3: "1"
                            }
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                            }
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in2: "shape",
                              result: "effect1_innerShadow_11510_19679"
                            }
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              in: "SourceAlpha",
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                              result: "hardAlpha"
                            }
                          }),
                          _c("feOffset", { attrs: { dy: "0.15" } }),
                          _c("feComposite", {
                            attrs: {
                              in2: "hardAlpha",
                              operator: "arithmetic",
                              k2: "-1",
                              k3: "1"
                            }
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              type: "matrix",
                              values:
                                "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                            }
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in2: "effect1_innerShadow_11510_19679",
                              result: "effect2_innerShadow_11510_19679"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "filter",
                        {
                          attrs: {
                            id: "filter1_i_11510_19679",
                            x: "10.6074",
                            y: "20.001",
                            width: "16.6855",
                            height: "12.8604",
                            filterUnits: "userSpaceOnUse",
                            "color-interpolation-filters": "sRGB"
                          }
                        },
                        [
                          _c("feFlood", {
                            attrs: {
                              "flood-opacity": "0",
                              result: "BackgroundImageFix"
                            }
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in: "SourceGraphic",
                              in2: "BackgroundImageFix",
                              result: "shape"
                            }
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              in: "SourceAlpha",
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                              result: "hardAlpha"
                            }
                          }),
                          _c("feOffset", { attrs: { dy: "-0.15" } }),
                          _c("feComposite", {
                            attrs: {
                              in2: "hardAlpha",
                              operator: "arithmetic",
                              k2: "-1",
                              k3: "1"
                            }
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                            }
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in2: "shape",
                              result: "effect1_innerShadow_11510_19679"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            id: "paint0_linear_11510_19679",
                            x1: "21.9723",
                            y1: "8.70884",
                            x2: "5.19033",
                            y2: "25.4908",
                            gradientUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("stop", { attrs: { "stop-color": "#00A0FF" } }),
                          _c("stop", {
                            attrs: { offset: "0.0066", "stop-color": "#00A1FF" }
                          }),
                          _c("stop", {
                            attrs: { offset: "0.2601", "stop-color": "#00BEFF" }
                          }),
                          _c("stop", {
                            attrs: { offset: "0.5122", "stop-color": "#00D2FF" }
                          }),
                          _c("stop", {
                            attrs: { offset: "0.7604", "stop-color": "#00DFFF" }
                          }),
                          _c("stop", {
                            attrs: { offset: "1", "stop-color": "#00E3FF" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            id: "paint1_linear_11510_19679",
                            x1: "34.0048",
                            y1: "20.0006",
                            x2: "9.80891",
                            y2: "20.0006",
                            gradientUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("stop", { attrs: { "stop-color": "#FFE000" } }),
                          _c("stop", {
                            attrs: { offset: "0.4087", "stop-color": "#FFBD00" }
                          }),
                          _c("stop", {
                            attrs: { offset: "0.7754", "stop-color": "#FFA500" }
                          }),
                          _c("stop", {
                            attrs: { offset: "1", "stop-color": "#FF9C00" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            id: "paint2_linear_11510_19679",
                            x1: "24.9995",
                            y1: "22.2949",
                            x2: "2.24102",
                            y2: "45.0534",
                            gradientUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("stop", { attrs: { "stop-color": "#FF3A44" } }),
                          _c("stop", {
                            attrs: { offset: "1", "stop-color": "#C31162" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            id: "paint3_linear_11510_19679",
                            x1: "7.46882",
                            y1: "0.176501",
                            x2: "17.6311",
                            y2: "10.3388",
                            gradientUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("stop", { attrs: { "stop-color": "#32A071" } }),
                          _c("stop", {
                            attrs: { offset: "0.0685", "stop-color": "#2DA771" }
                          }),
                          _c("stop", {
                            attrs: { offset: "0.4762", "stop-color": "#15CF74" }
                          }),
                          _c("stop", {
                            attrs: { offset: "0.8009", "stop-color": "#06E775" }
                          }),
                          _c("stop", {
                            attrs: { offset: "1", "stop-color": "#00F076" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-056ed092", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056ed092","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/download-app/_slug.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-056ed092","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/download-app/_slug.vue
// module chunks = 25